
<div class="row wp-image-text">
    <div class="wp-image-text-image" style="text-align: center;">
        <img class="img-fluid mx-auto d-block" [src]="brandLogoImage" >
    </div>
</div>


